import { render, staticRenderFns } from "./CalendarMinus.vue?vue&type=template&id=d63381e6"
import script from "./CalendarMinus.vue?vue&type=script&lang=js"
export * from "./CalendarMinus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports